import { render, staticRenderFns } from "./Dash.vue?vue&type=template&id=b27bac6e&lang=pug&"
import script from "./Dash.vue?vue&type=script&lang=js&"
export * from "./Dash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports